import { css } from '@emotion/react';
import { FreeTextQuestion as IFreeTextQuestion } from '__generated__/graphql';
import { QuestionHeading } from './question-heading';
import { Textarea } from '@mantine/core';
import { useCallback, useEffect } from 'react';
import { FormUtils } from './form-utils';
import { useFormContext } from 'react-hook-form';
import { Correction } from './correction';

interface Props {
    question: IFreeTextQuestion;
    showCorrect?: boolean;
    overrideSelection?: unknown;
}

export function FreeTextQuestion(props: Props) {
    const { showCorrect, question, overrideSelection } = props;
    const questionId = `FreeTextQuestion.q-${question.id}`;
    const methods = useFormContext();
    const { register, watch, setValue: formSetValue } = methods;
    const value = watch(`${questionId}.answer`);

    const setValue = useCallback((val: string) => formSetValue(`${questionId}.answer`, val), [formSetValue]);

    console.log('ftq', { props })

    useEffect(() => {
        FormUtils.registerQuestion({
            questionId: questionId,
            questionType: 'FreeTextQuestion',
            register
        });
    }, [questionId, register]);

    // useEffect(() => {
    //     if (!!overrideSelection) {
    //         setValue(overrideSelection.grading?.submittedStudentAnswerText as string);
    //     }
    // }, [overrideSelection, questionId, setValue]);

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
            `}
        >
            <QuestionHeading>{question.text}</QuestionHeading>
            {/* <QuestionHeading showCorrect={showCorrect} isCorrect={overrideSelection?.grading?.result === 'CORRECT'}>
                {question.text}
            </QuestionHeading> */}
            <Textarea readOnly={showCorrect} onChange={(e) => setValue(e.target.value)} value={value} placeholder="Type your answer here" />
            {/* {showCorrect && <Correction>{overrideSelection?.grading?.reason}</Correction>} */}
        </div>
    );
    return <div>stub </div>;
}
